import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { urlsConfig } from 'src/configs';
import { errorLocals } from 'src/locals';

declare module 'axios' {
  export interface AxiosRequestConfig {
    blockSpinner?: boolean;
    blockErrorHandler?: boolean;
  }
}

const { CancelToken } = axios;

const axiosInstance = axios.create({
  baseURL: urlsConfig.webServerBaseURL,
});

const configureInterceptors = (
  setAnyPendingRequest: (value: boolean) => void,
  handleResponseErrors: (error: AxiosError) => boolean,
) => {
  let pendingRequestsNumber = 0;

  axios.interceptors.request.use(
    (config: AxiosRequestConfig & { blockSpinner?: boolean }) => {
      pendingRequestsNumber += 1;

      if (!config.blockSpinner) {
        setAnyPendingRequest(true);
      }

      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    },
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      pendingRequestsNumber -= 1;
      if (pendingRequestsNumber === 0) setAnyPendingRequest(false);

      return response;
    },
    (error: AxiosError) => {
      pendingRequestsNumber -= 1;
      if (pendingRequestsNumber === 0) setAnyPendingRequest(false);
      // const handled = handleResponseErrors(error);

      // if (handled) return Promise.reject(errorLocals.errorHandledError);

      return Promise.reject(error);
    },
  );
};

const setToken = (newToken?: string) => {
  axiosInstance.defaults.headers.Authorization = newToken ? `Bearer ${newToken}` : undefined;
};

const setEventId = (id?: string) => {
  // @ts-ignore
  axiosInstance.defaults.headers.eventid = id || undefined;
};

export default {
  ...axiosInstance,
  configureInterceptors,
  setToken,
  setEventId,
  CancelToken,
};
